// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/financial/Income.css
// module id = 1345
// module chunks = 0